// extracted by mini-css-extract-plugin
export default {"left-item-wrapper":"_2EI8s","leftItemWrapper":"_2EI8s"};